import { getAttempts } from '@/modules/loading-page/api/getCheck';
import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AttemptsData } from '@/modules/loading-page/types';

export const useGetFreeCheckAttempts = ({
  initialData,
  disableInvoke = false,
}: {
  initialData: AttemptsData;
  disableInvoke?: boolean;
}) => {
  const [shouldFetch, setShouldFetch] = useState(disableInvoke);

  const { data, isLoading, error, refetch } = useQuery<AttemptsData, Error>({
    queryKey: [`free-attempts`],
    queryFn: async () => getAttempts(),
    enabled: shouldFetch,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    initialData,
  });

  useEffect(() => {
    if (disableInvoke) return;

    const controller = new AbortController();

    const firstInteraction = async () => {
      setShouldFetch(true);
      controller.abort();
    };

    ['click', 'scroll', 'mousemove', 'touchstart'].forEach(function (e) {
      window.addEventListener(e, firstInteraction, {
        once: true,
        passive: true,
        signal: controller.signal,
      });
    });

    return () => {
      controller.abort();
    };
  }, []);

  return { data, isLoading, error, checkAttempts: refetch };
};
